import classNames from "classnames";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const Input: FC<any> = (props) => {
  const { t } = useTranslation();
  const {
    label,
    name,
    id,
    type = "text",
    styleLayout,
    styleLabel,
    styleInput,
    onChange,
    placeholder,
    ...rest
  } = props;

  const handleChange = (e: any) => {
    if (onChange) onChange(e.target.value);
  };

  return (
    <div className={classNames("w-full", styleLayout)}>
      {label && (
        <label
          className={classNames(
            "block text-sm font-medium leading-6 text-gray-500 mb-2",
            styleLabel
          )}
        >
          {t(label)}
        </label>
      )}
      <input
        {...rest}
        type={type}
        name={name}
        id={id}
        className={classNames(
          "block w-full px-3 py-2 border border-gray-200 placeholder:text-gray-500 focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-600 rounded-lg",
          styleInput
        )}
        onChange={handleChange}
        placeholder={placeholder ? t(placeholder) : undefined}
      />
    </div>
  );
};

export default Input;
